const filterInitial = {
  status: "all",
  colors: [],
};
export default filterInitial;
